import { render, staticRenderFns } from "./MakeAnEntryPhoto.vue?vue&type=template&id=076ba21e&lang=pug&"
import script from "./MakeAnEntryPhoto.vue?vue&type=script&lang=js&"
export * from "./MakeAnEntryPhoto.vue?vue&type=script&lang=js&"
import style0 from "./MakeAnEntryPhoto.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports